


























import { TweenMax } from 'gsap'
import { gallerySlides } from '../content/gallery'
import { mapState, mapMutations } from 'vuex'
import Swiper from 'swiper/js/swiper.js'

export default {
  name: "Gallery",
  data() {
    return {
      gallerySlides: gallerySlides,
      activeIndex: 0 as Number,
      buttonNextIsBlocked: false,
      buttonPrevIsBlocked: true,
      swiper: null,
      tabs: [
        {label: 'видовые террасы', startIndex: 0, active: true},
        {label: 'интерьеры', startIndex: 12, active: false}
      ]
    }
  },
  computed: {
    ...mapState(['showGallery', 'wentToGalleryFromSlider', 'windowWidth']),
    isMobile() {
      return window.innerWidth < 1000
    }
  },
  watch: {
    activeIndex() {
      if (this.activeIndex < this.tabs[1].startIndex) {
        this.tabs[0].active = true;
        this.tabs[1].active = false;
      } else {
        this.tabs[0].active = false;
        this.tabs[1].active = true;
      }
    }
  },
  mounted() {
    if (this.windowWidth < 1000) this.initSwiper()
  },
  beforeDestroy() {
    if (this.wentToGalleryFromSlider) this.setGalleryEntranceFromSlider();
  },
  methods: {
    ...mapMutations(['toggleGallery','setGalleryEntranceFromSlider']),
    initSwiper() {
      this.swiper = new Swiper(this.$refs.swiper);
      debugger
      this.swiper.on("slideNextTransitionStart", () => {
        this.activeIndex++;
        this.buttonPrevIsBlocked = false;
        this.buttonNextIsBlocked = this.activeIndex === (gallerySlides.length - 1) ? true : false;
      });
      this.swiper.on("slidePrevTransitionStart", () => {
        if (this.activeIndex !== 0) this.activeIndex--;
        this.buttonPrevIsBlocked = this.activeIndex === 0 ? true : false
      })
      
    },
    nextSlide() {
      this.buttonPrevIsBlocked = false;
      if (this.activeIndex < (gallerySlides.length - 2)) {
        
        if (this.windowWidth < 1000) {
          this.swiper.slideNext();
          return
        }
        this.activeIndex++;
        TweenMax.to(this.$refs.container, .5, {x: `-${window.innerWidth * this.activeIndex}`})
      } else {
        
        if (this.windowWidth < 1000) {
          this.swiper.slideNext();
          return
        }
        this.activeIndex++;
        TweenMax.to(this.$refs.container, .5, {x: `-${window.innerWidth * this.activeIndex}`})
        this.buttonNextIsBlocked = true;
      }
    },
    prevSlide() {
      this.buttonNextIsBlocked = false;
      if (this.activeIndex < gallerySlides.length && this.activeIndex > 1) {
        
        if (this.windowWidth < 1000) {
          this.swiper.slidePrev();
          return
        }
        this.activeIndex--;
        TweenMax.to(this.$refs.container, .5, {x: `-${window.innerWidth * this.activeIndex}`})
      } else {
        
        this.buttonPrevIsBlocked = true;
        if (this.windowWidth < 1000) {
          this.swiper.slidePrev();
          return
        }
        this.activeIndex--;
        TweenMax.to(this.$refs.container, .5, {x: `-${window.innerWidth * this.activeIndex + 0.001}`})
      }
    },
    goToSlide(slideIndex, tabIndex) {
      this.activeIndex = slideIndex;
      
      if (this.windowWidth < 1000) {
        this.swiper.slideTo(slideIndex,0)
      } else {
        TweenMax.to(this.$refs.container, 0, {x: `-${window.innerWidth * this.activeIndex + 0.001}`});
      }
      
      this.tabs.forEach(tab => {tab.active = false});
      this.tabs[tabIndex].active = true;
      if (this.activeIndex === gallerySlides.length - 1) {
        this.buttonNextIsBlocked = true;
        this.buttonPrevIsBlocked = false;
      } else if (this.activeIndex === 0){
        this.buttonNextIsBlocked = false;
        this.buttonPrevIsBlocked = true;
      } else {
        this.buttonNextIsBlocked = false;
        this.buttonPrevIsBlocked = false;
      }
    }
  }
}
